if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const isLoginRequired = this.form.dataset.loginRequired;
        console.log("isLoginRequired " + isLoginRequired);

        const loginModal = document.querySelector("#login-modal");

        if (isLoginRequired == "true") {
          loginModal.style.display = "block";
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const currentProductId = parseInt(this.form.querySelector('[name="id"]').value);
        console.log( currentProductId + "currentProductId");
        
        const isActivityBookProduct = window.activityBookProductIds.some(p => parseInt(p.product_id) === currentProductId);
          console.log("isActivityBookProduct" + isActivityBookProduct );
          
        if (isActivityBookProduct) {
          const alreadyOrdered = window.customerOrderLineItemIds.some(item => parseInt(item.line_item_id) === currentProductId);
          if (alreadyOrdered) {
            alert("You've already received this free book in a previous order.");
            return;
          }

          const cartData = await fetch('/cart.js').then(res => res.json());
          console.log(" hii"+ cartData);
          
          const cartHasAnyActivityBookProduct = cartData.items.some(item =>
            window.activityBookProductIds.some(freeBook => parseInt(freeBook.product_id) === item.variant_id)
          );

          if (cartHasAnyActivityBookProduct) {
            alert("Only one free book is allowed in the cart.");
            return;
          }
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const giftContainerElement = document.querySelector(".gift-wrap-container input");
        let giftWrapInputStatus = false;
        if (giftContainerElement) {
          giftWrapInputStatus = giftContainerElement.checked;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          if (this.classList.contains("pdp-product-gift-block") && giftWrapInputStatus) {
            let giftWrapInput = giftWrapInputStatus ? "Yes" : "No";
            formData.append("properties[GiftWrap]", giftWrapInput);
            let giftProducts = this.getAttribute("data-gift_products");
            if (giftProducts) {
              formData.append("properties[GiftProducts]", giftProducts);
            }
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
